module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b90a17057bbf66504884041c3f09bc53.png";